import { FormProvider, useForm } from "react-hook-form";

import {
    faArrowRight,
    faAt,
    faDice,
    faEdit,
    faSms,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Modal } from "react-bootstrap";

import { IEmailConta } from "../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { IConfigRegua } from "../../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";

import Geral from "./Geral";
import Email from "./Email";
import SMS from "./SMS";

import { IRegua } from "../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import {
    AtualizarConfigReguaController,
    CadastrarConfigReguaController,
} from "../../../../../Controllers/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaControllers";

interface ICadastrarEditarConfigReguaProps {
    configRegua?: IConfigRegua;
    lstEmails: Array<IEmailConta>;
    lstRegua: Array<IRegua>;
    updateList: () => void;
    setShow?: (show: boolean) => void;
}

interface ICadastrarEditarConfigReguaFormData extends IConfigRegua {
    cDS_SENHA_SMS: string;
}

export function CadastrarEditarConfigRegua(
    props: ICadastrarEditarConfigReguaProps
) {
    const form = useForm<ICadastrarEditarConfigReguaFormData>();

    function handleCadastrarEditarConfigReguaFormSubmit(
        formData: ICadastrarEditarConfigReguaFormData
    ) {
        if (formData.DS_SENHA_SMS !== formData.cDS_SENHA_SMS) {
            form.setError("cDS_SENHA_SMS", {
                types: {},
                message: "Senha não corresponde",
            });
        }
        const exec = props.configRegua
            ? AtualizarConfigReguaController
            : CadastrarConfigReguaController;
        const execProps = props.configRegua
            ? {
                  ...formData,
                  ID_CASO_COBRANCA_REGUA_CONFIG:
                      props.configRegua.ID_CASO_COBRANCA_REGUA_CONFIG,
              }
            : formData;

        exec(execProps).then(() => {
            props.updateList();
            if (props.setShow) props.setShow(false);
        });
    }

    return (
        <FormProvider {...form}>
            <form
                className="tab-content"
                id="ConfigReguaToolsForm"
                onSubmit={form.handleSubmit(
                    handleCadastrarEditarConfigReguaFormSubmit
                )}
            >
                <div
                    className="tab-pane fade active show"
                    id="InformacaoConfig"
                    role="tabpanel"
                    aria-labelledby="InformacaoConfig"
                >
                    <Geral
                        configRegua={props.configRegua}
                        lstRegua={props.lstRegua}
                    />
                </div>
                <div
                    className="tab-pane fade"
                    id="Email"
                    role="tabpanel"
                    aria-labelledby="Email"
                >
                    <Email
                        configRegua={props.configRegua}
                        lstEmails={props.lstEmails}
                    />
                </div>
                <div
                    className="tab-pane fade"
                    id="SMS"
                    role="tabpanel"
                    aria-labelledby="SMS"
                >
                    <SMS configRegua={props.configRegua} />
                </div>
            </form>
        </FormProvider>
    );
}

export function CadastrarEditarConfigReguaHeader(
    tipo: "Cadastrar" | "Atualizar"
) {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title"
            >
                <h3 className="card-label">
                    <FontAwesomeIcon icon={faArrowRight} className="mr-2" />
                    {tipo} Configuração de Régua
                </h3>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#ConfigReguaHeaderTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#InformacaoConfig"
                            data-toggle="tab"
                            data-target="#InformacaoConfig"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faDice} />
                            </span>
                            <span className="nav-text">Geral</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#Email"
                            data-toggle="tab"
                            data-target="#Email"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faAt} />
                            </span>
                            <span className="nav-text">Email</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#SMS"
                            data-toggle="tab"
                            data-target="#SMS"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faSms} />
                            </span>
                            <span className="nav-text">SMS</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}

export function CadastrarEditarConfigReguaFooter(
    tipo: "Cadastrar" | "Atualizar"
) {
    return (
        <div className="col-12">
            <button
                type="submit"
                form="ConfigReguaToolsForm"
                className="btn btn-outline-success font-weight-bold col-12 justify-content-center"
            >
                <FontAwesomeIcon icon={faEdit} size="lg" className="mr-1" />{" "}
                {tipo} dados
            </button>
        </div>
    );
}
